import type { FaireProductEntity } from "../../entity_types/product";

export const p_fdasafff9z: FaireProductEntity = {
  token: "p_fdasafff9z",
  type: "product",
  name: "Small Crystal Animal Figurines, Owls, Wolf, Axolotl",
  brandToken: "b_fak8czuqg9",
  brandName: "Mandala Gems",
  imageUrl:
    "https://cdn.faire.com/fastly/b3f70601be46f74336cfb72b7b4cc251279acc8c8e642d1c31332d9b092c9aa7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/35cec1fbc691533c01532fddbdf0ef411f1cfdf1f003654840dc0724549d0a44.png",
  ],
  priceDollars: 5.5,
  description:
    "Crystal Animal Figurines – Wolf, Owl & Axolotl Carvings\n\nA small gathering of companions in stone.\n\nThese hand-carved crystal animals bring personality to shelves and displays — the quiet watchfulness of the owl, the loyal presence of the wolf, and the soft, curious charm of the axolotl. Each one is shaped from natural crystal, polished smooth, and sized to feel comforting in the hand.\n\nCarved from a rotating mix of stones including Strawberry Quartz, Selenite, Rose Quartz, Sodalite, Green Aventurine, Pyrite, Orange Calcite, Jasper, Obsidian, Amethyst and more, every restock feels a little different and encourages collecting.\n\nThey’re the kind of pieces customers instinctively pick up, smile at, and start assigning meaning to.\n\nPerfect for:\n• Gift shoppers and younger customers\n• Nature and animal lovers\n• Pocket companions and desk friends\n• Add-on purchases near checkout\n\nRetail appeal:\n• Broad age appeal (kids through adults)\n• Easy collectible category\n• Great mix-and-match display options\n• Reliable repeat sellers\n\nEach carving varies slightly in expression, pattern, and stone type, giving every animal its own character.\n\nSmall, friendly, and easy to love — little guardians waiting to be chosen.\n",
  tags: [],
  msrpDollars: 11,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:54.080Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
